<loren-trace-dialog title="operations.feature_select" (continue)="continue()"
  >@if (formModel) {
  <loren-entity-form
    [formModel]="formModel"
    (formFieldInteraction)="handleFormFieldInteraction($event)"
    >
    </loren-entity-form
    >
  }</loren-trace-dialog>
